<template>
  <div v-if="$currentApp" class="actions-value-wrapper">
    <UiSwitch
      id="blockGpay"
      ref="toggleSwitcher"
      :title="toggleSwitcherTitle"
      :is-checked-initial="!isBlockedGpay || isDeactivated"
      :is-disabled="isBlockedGpay || isDeactivated"
      @input="gPayActionClicked"
    />
  </div>
</template>

<script>
import UiSwitch from '@/components/UiSwitch.vue';
import currentApplicationMixin from '../mixins/currentApplicationMixin'

import { blockGpay, unblockGpay } from './GpayActionsMethods.js'

export default {
  components: {
    UiSwitch
  },
  mixins: [currentApplicationMixin],
  computed: {
    isBlockedGpay() {
      return this.$currentApp && this.$currentApp.google_cert === 'prohibited_activities'
    },
    isDeactivated() {
      return this.$currentApp && this.$currentApp.google_cert === null
    },
    actionsHelper() {
      return this.isBlockedGpay
        ? {
            action: 'unblockGpay',
            buttonText: 'Разблокировать Google Pay',
            status: 'Разблокировать',
          }
        : {
            action: 'blockGpay',
            buttonText: 'Заблокировать Google Pay',
            status: 'Заблокировать',
          }
    },
    toggleSwitcherTitle() {
      if (this.isDeactivated) {
        return 'Google Pay для данного аккаунта не активирован';
      }

      if (this.isBlockedGpay) {
        return 'Google Pay для данного аккаунта заблокирован';
      }

      return this.actionsHelper.buttonText;
    }
  },
  methods: {
    async gPayActionClicked(action) {
      this.$refs.toggleSwitcher.isDisabledAttr = true
      /** {object} `actionsHashes` Object contains all actions */
      const actionsHashes = { blockGpay, unblockGpay }

      const result = await actionsHashes[this.actionsHelper.action].call(this)

      if (!result.isConfirmed) {
        this.$refs.toggleSwitcher.resetSwitcher();
      }

      if (result.isConfirmed && result.value) {
        this.setGoogleCertStatus(result.value.data.GoogleCert);
      }
    },

    /**
     * Update google cert status without backend request.
     */
    setGoogleCertStatus(status) {
      if (!status) return

      this.$store.commit('application/SET_CURRENT_APPLICATION', {
        ...this.$currentApp,
        google_cert: status,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.actions-value-wrapper {
  @include createFlex(flexbox, nowrap, row, flex-end, stretch, center);

  .action-icon {
    display: inline-block;
    margin: 0 0 0 rem(8px);
    cursor: pointer;
  }
}

.actions-value-text {
  margin-right: 12px;
}
</style>
